__turbopack_context__.v({
  "black": "mN-ATq_black",
  "black100": "mN-ATq_black100",
  "black1000": "mN-ATq_black1000",
  "black200": "mN-ATq_black200",
  "black300": "mN-ATq_black300",
  "black400": "mN-ATq_black400",
  "black500": "mN-ATq_black500",
  "black600": "mN-ATq_black600",
  "black700": "mN-ATq_black700",
  "black800": "mN-ATq_black800",
  "black900": "mN-ATq_black900",
  "blue200": "mN-ATq_blue200",
  "blue400": "mN-ATq_blue400",
  "blue600": "mN-ATq_blue600",
  "blue800": "mN-ATq_blue800",
  "blue900": "mN-ATq_blue900",
  "green200": "mN-ATq_green200",
  "green400": "mN-ATq_green400",
  "green600": "mN-ATq_green600",
  "green800": "mN-ATq_green800",
  "green900": "mN-ATq_green900",
  "headerWrapper": "mN-ATq_headerWrapper",
  "label": "mN-ATq_label",
  "labelWithBetaItems": "mN-ATq_labelWithBetaItems",
  "pink200": "mN-ATq_pink200",
  "pink400": "mN-ATq_pink400",
  "pink600": "mN-ATq_pink600",
  "pink800": "mN-ATq_pink800",
  "purple200": "mN-ATq_purple200",
  "purple400": "mN-ATq_purple400",
  "purple600": "mN-ATq_purple600",
  "purple800": "mN-ATq_purple800",
  "purple900": "mN-ATq_purple900",
  "red200": "mN-ATq_red200",
  "red400": "mN-ATq_red400",
  "red600": "mN-ATq_red600",
  "red800": "mN-ATq_red800",
  "red900": "mN-ATq_red900",
  "sky1000": "mN-ATq_sky1000",
  "title": "mN-ATq_title",
  "useCaseLendingRed": "mN-ATq_useCaseLendingRed",
  "white": "mN-ATq_white",
  "wrapper": "mN-ATq_wrapper",
  "yellow200": "mN-ATq_yellow200",
  "yellow400": "mN-ATq_yellow400",
  "yellow600": "mN-ATq_yellow600",
  "yellow800": "mN-ATq_yellow800",
  "yellow900": "mN-ATq_yellow900",
});
